"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Pagination = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const Pagination_1 = __importDefault(require("@material-ui/lab/Pagination"));
const utils_1 = require("../lib/utils");
const theme_1 = __importDefault(require("../styles/theme"));
/**
 *
 * Pagination Usage Example:
 *
 * <Pagination />
 *
 * WARNING: Before changing this file, please strongly consider whether your change is
 * necessary (we want to avoid unexpected bugs in other views).
 * This code is meant to be shared by many views throughout our app and should not
 * contain logic specifc to how your view is using it.
 *
 */
const StyledPagination = styled_components_1.default(Pagination_1.default) `
  .Mui-selected {
    color: ${theme_1.default.colors.primaryAccent};
  }

  .MuiPaginationItem-page.Mui-selected {
    background-color: ${theme_1.default.colors.backgroundPrimaryAccent};
  }
`;
const Pagination = ({ onChange, count, activePage, hideNextButton, hidePrevButton, disabled, }) => (react_1.default.createElement(StyledPagination, { "data-testid": "pagination", shape: "rounded", count: count, page: activePage, hideNextButton: hideNextButton, hidePrevButton: hidePrevButton, disabled: disabled, onChange: onChange ? (event, page) => onChange(page, event) : utils_1.noop }));
exports.Pagination = Pagination;
exports.default = exports.Pagination;
